import React from 'react';
import { Button, SubContent, Table, PopConfirm } from '@maxtropy/components';
import { Space } from 'antd';
import { DeviceCategory, DeviceConfig } from '../types';

interface DeviceSectionProps {
  title: string;
  devices: DeviceConfig[];
  isEdit: boolean;
  deviceType: DeviceCategory;
  onAddDevice: () => void;
  onDeleteDevice: (deviceId: number) => void;
  onConfigThreshold: (device: DeviceConfig) => void;
}

const DeviceSection: React.FC<DeviceSectionProps> = ({
  title,
  devices,
  isEdit,
  deviceType,
  onAddDevice,
  onDeleteDevice,
  onConfigThreshold,
}) => {
  const columns = [
    {
      title: '设备名称',
      dataIndex: 'name',
      width: 300,
    },
    {
      title: '操作',
      width: 140,
      render: (_: unknown, record: DeviceConfig) => (
        <Space size={16}>
          <Button type="link" disabled={!isEdit} onClick={() => onConfigThreshold({ ...record, deviceType })}>
            配置指标阈值
          </Button>
          <PopConfirm
            title="确认删除"
            description="确定要删除该设备吗？"
            onConfirm={() => onDeleteDevice(record.deviceId)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" disabled={!isEdit} danger>
              删除
            </Button>
          </PopConfirm>
        </Space>
      ),
    },
  ];

  return (
    <SubContent title={title}>
      <Button type="primary" disabled={!isEdit} onClick={onAddDevice} wrapStyle={{ marginBottom: 10 }}>
        选择设备
      </Button>
      <Table
        rowKey="deviceId"
        columns={columns}
        dataSource={devices}
        pagination={false}
        locale={{ emptyText: '暂无设备，请点击"选择设备"按钮添加' }}
      />
    </SubContent>
  );
};

export default DeviceSection;
